import {MDCTextField} from '@material/textfield'

el = document.querySelector('#search')
new MDCTextField(el.parentElement) if el